import { BULK_UPDATE_MAX_CAP_FAILURE, BULK_UPDATE_MAX_CAP_REQUEST, BULK_UPDATE_MAX_CAP_RESET, BULK_UPDATE_MAX_CAP_SUCCESS } from "redux/actions/action-type";

const initialState = {
    isBulkUpdateLoading: false,
    isBulkUpdateSuccess: false,
    isBulkUpdateFail: false,
    bulkUpdateMaxCapResponse: {},
};

export const bulkUpdateMaxCapReducer = (state = initialState, { type, bulkUpdateMaxCapResponse }) => {
    switch (type) {
        case BULK_UPDATE_MAX_CAP_REQUEST:
            return {
                ...state,
                isBulkUpdateLoading: true,
                isBulkUpdateSuccess: false,
                isBulkUpdateFail: false,
            };
        case BULK_UPDATE_MAX_CAP_SUCCESS:
            return {
                ...state,
                bulkUpdateMaxCapResponse: bulkUpdateMaxCapResponse,
                isBulkUpdateLoading: false,
                isBulkUpdateSuccess: true,
                isBulkUpdateFail: false,
            };
        case BULK_UPDATE_MAX_CAP_FAILURE:
            return {
                ...state,
                bulkUpdateMaxCapResponse: bulkUpdateMaxCapResponse,
                isBulkUpdateLoading: false,
                isBulkUpdateSuccess: false,
                isBulkUpdateFail: true,
            };
        case BULK_UPDATE_MAX_CAP_RESET:
            return { ...initialState };
        default:
            return { ...state };
    }
};
